import React from 'react'
import {Box} from "@mui/material";

import { ActionButton } from "@components";
import {keywordFilters} from "../../@signals";


export default function KeywordsTableToolbar() {
    return <Box display="flex" gap={2}>
        <ActionButton
            label="Associate From Keyword"
            icon="link"
            onClick={() => keywordFilters.value = {
                customerID: null,
                createMode: false,
                categoryID: null,
                keywordName: '',
                keywordType: null,
                keywordID: null,
                siteID: [],
                associateMode: true
            }}
        />
        <ActionButton
            label="Create New Keyword"
            icon="hexagon-plus"
            onClick={() => keywordFilters.value = {
                customerID: null,
                createMode: true,
                associateMode: false,
                categoryID: null,
                keywordName: '',
                keywordID: null,
                keywordType: null,
                siteID: []
            }}
        />
    </Box>
}